export default __webpack_public_path__ + "static/media/signup-background.f557de65.png";